import { useTracking } from '@vp/react-tracking';
import { useEffect } from 'react';
import { ErrorLoadingState, TRACKING_PAGE_MY_ACCOUNT } from '@99designs/collaborate-views';
import {
    ActivityPanel,
    useActionContext,
    useActivityPanelData,
    useHandleRequestRevision,
} from '@99designs/collaborate-views';
import { useCollaborationContext } from '@99designs/collaborate-views';
import { __ } from '@99designs/i18n';

export type ActivityRouteParams = {
    deliveryVersionId: string;
};

export const Activity = () => {
    const { tracking } = useTracking();
    const {
        collaborationId,
        latestVersion,
        revisionRequests,
        trackingProperties,
        hasDesignLiveDelivery,
    } = useCollaborationContext();
    const { actionOptions } = useActionContext();

    const {
        chatEvents,
        loading: activityLoading,
        error: activityError,
    } = useActivityPanelData({
        collaborationPublicId: collaborationId,
        maxRevisionRequests: revisionRequests.max,
        isDesignLive: hasDesignLiveDelivery,
    });

    const {
        handleRequestRevision,
        loading: updateRevisionLoading,
        error: updateRevisionError,
    } = useHandleRequestRevision(collaborationId, latestVersion.toString());

    useEffect(() => {
        tracking.page('Design Services:Collaboration:Activity', {
            ...trackingProperties,
            pageName: `Design Services:Collaboration:Activity:${trackingProperties.collaborationStatus}`,
            pageSection: TRACKING_PAGE_MY_ACCOUNT,
            pageStage: TRACKING_PAGE_MY_ACCOUNT,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ErrorLoadingState
            loading={activityLoading || updateRevisionLoading}
            errors={activityError || updateRevisionError}
            data={chatEvents}
        >
            {(chatEvents) => (
                <ActivityPanel
                    events={chatEvents}
                    requestRevision={actionOptions.requestRevision}
                    onRequestRevisionClick={handleRequestRevision}
                    approve={actionOptions.approve}
                />
            )}
        </ErrorLoadingState>
    );
};
